import { FormattedMessage } from "react-intl";
import ActiveIndicator from "../../../Shared/ActiveIndicator/ActiveIndicator";
import NoDataIndicator from "../../../Shared/NoDataIndicator/NoDataIndicator";
import StudyIcon from "../../../Shared/StudyIcon/StudyIcon";
import ManagementHeader, {
  ManagementHeaderDivider,
} from "../../ManagementHeader/ManagementHeader";
import UsersCount from "../../ManagementHeader/UsersCount/UsersCount";
import SubjectsCount from "../SubjectsCount/SubjectsCount";

type ManageStudiesHeaderProps = {
  studies?: {
    total?: number;
    active?: number;
    inactive?: number;
  };
  users?: {
    total?: number;
    active?: number;
    inactive?: number;
  };
  totalSubjects?: number;
};

const ManageStudiesHeader = ({
  studies,
  users,
  totalSubjects,
}: ManageStudiesHeaderProps) => {
  return (
    <ManagementHeader className="d-lg-flex justify-content-end">
      <div className="d-flex">
        <StudiesCount {...studies} />
        <ManagementHeaderDivider />
      </div>
      &nbsp;
      <div className="d-flex">
        <UsersCount extended {...users} />
        <ManagementHeaderDivider />
      </div>
      &nbsp;
      <SubjectsCount extended total={totalSubjects} />
    </ManagementHeader>
  );
};
export default ManageStudiesHeader;

type StudiesCountProps = {
  total?: number;
  active?: number;
  inactive?: number;
};

const StudiesCount = ({ total, active, inactive }: StudiesCountProps) => {
  return (
    <div className="d-flex align-items-center">
      <div className="d-flex align-items-center">
        <StudyIcon className="mx-lg-1" size="sm" />
        <strong className="px-1 px-lg-0">
          <FormattedMessage id="MANAGEMENT.STUDIES" defaultMessage="Studies" />:
        </strong>
        &nbsp;
        <FormattedMessage id="GLOBAL.TOTAL" defaultMessage="Total" />
        &nbsp;{total ?? <NoDataIndicator />}
      </div>

      <div className="mx-2"></div>
      <div className="d-flex align-items-center">
        <ActiveIndicator active />
        &nbsp;
        <FormattedMessage id="MANAGEMENT.ACTIVE" defaultMessage="Active" />
        &nbsp;{active ?? <NoDataIndicator />}
      </div>

      <div className="mx-2"></div>
      <div className="d-flex align-items-center">
        <ActiveIndicator />
        &nbsp;
        <FormattedMessage
          id="MANAGEMENT.DEACTIVATED"
          defaultMessage="Deactivated"
        />
        &nbsp;{inactive ?? <NoDataIndicator />}
      </div>
    </div>
  );
};
